<div class="eva-message" *ngIf="message">

    <!-- EVA Logo -->
    <div class="eva-logo-col">
        <img class="eva-logo" src="../../../../assets/Ecolab-Virtual-Agent-Chat-Logo.svg" alt="EVA" />
    </div>

    <!-- Message Content -->
    <div class="eva-content-col">

        <!-- Timestamp -->
        <p class="eva-timestamp">{{ formattedTime }}</p>

        <!-- Message body -->
        <div class="eva-copy">
            <app-content-renderer
                [content]="message.content"
                [isBotMessage]="true">
            </app-content-renderer>
        </div>

        <!-- Suggestion pills -->
        <div class="eva-suggestions" *ngIf="suggestions.length">
            <button
                *ngFor="let suggestion of suggestions"
                class="suggestion-pill"
                type="button"
                (click)="onSuggestionClick(suggestion)">
                <span class="suggestion-text">{{ suggestion }}</span>
                <img class="suggestion-arrow" src="../../../../assets/Icon-Navigation.svg" alt="" />
            </button>
        </div>

        <!-- Action icons -->
        <div class="eva-actions">
            <!-- Copy -->
            <button class="action-btn" type="button" [title]="copySuccess ? 'Copied!' : 'Copy'" (click)="onCopy()" [class.copy-success]="copySuccess">
                <svg *ngIf="!copySuccess" class="action-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 1H4C2.9 1 2 1.9 2 3v14h2V3h12V1zm3 4H8C6.9 5 6 5.9 6 7v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                </svg>
                <svg *ngIf="copySuccess" class="action-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
            </button>
            <!-- Thumbs up -->
            <button class="action-btn" type="button" title="Like" (click)="onLike()">
                <svg class="action-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/>
                </svg>
            </button>
            <!-- Thumbs down (rotated) -->
            <button class="action-btn" type="button" title="Dislike" (click)="onDislike()">
                <svg class="action-icon" style="transform: rotate(180deg);" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/>
                </svg>
            </button>
            <!-- Text-to-speech -->
            <button class="action-btn" type="button" [title]="isReading ? 'Stop reading' : 'Read aloud'" (click)="onReadAloud()" [class.reading-active]="isReading">
                <svg *ngIf="!isReading" class="action-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                </svg>
                <svg *ngIf="isReading" class="action-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                </svg>
            </button>
        </div>

    </div>
</div>
